<mat-toolbar class="site-header">
  <nav class="nav-container" aria-label="Navegación principal">
    <a class="logo" routerLink="/" aria-label="Ir al inicio" (click)="closeMenu()">
      <span class="logo-text">Hane</span>
      <span class="logo-dot">.</span>
    </a>
    <div class="nav-links" [class.open]="menuOpen()">
      <a mat-button routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenu()">Inicio</a>
      <a mat-button routerLink="/archivo" routerLinkActive="active" (click)="closeMenu()">Archivo</a>
      <a mat-button routerLink="/sobre-mi" routerLinkActive="active" (click)="closeMenu()">Sobre mí</a>
    </div>
    <div class="nav-actions">
      <a mat-icon-button routerLink="/buscar" aria-label="Buscar" (click)="closeMenu()">
        <mat-icon>search</mat-icon>
      </a>
      <button mat-icon-button (click)="themeService.toggle()" [attr.aria-label]="themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
        <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>
      <button mat-icon-button class="menu-toggle" (click)="toggleMenu()" [attr.aria-label]="menuOpen() ? 'Cerrar menú' : 'Abrir menú'" aria-controls="nav-links">
        <mat-icon>{{ menuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </nav>
</mat-toolbar>
